import { createColumn, defaultColumns, inputTextField, relationField, booleanComponent } from '../_defaults/columns'
import { dateFormat } from '../../plugins/filters'

export const columns = [
  createColumn({
    label: 'Start Date',
    field: 'startDate',
    // section: 'Scheduling',
    type: 'date',
    displayValue: row => {
      return row.startDate ? dateFormat(row.startDate, 'MMM DD YYYY - h:mm a') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a',
        okLabel: 'Set Start',
        modal: true
        // dark: true
        // color: 'primary'
        // headerLabel: 'Start Date / Time'
      },
      validation: {
        required: true
      }
    }
  }),
  createColumn({
    label: 'End Date',
    field: 'endDate',
    // section: 'Scheduling',
    type: 'date',
    displayValue: row => {
      return row.endDate ? dateFormat(row.endDate, 'MMM DD YYYY - h:mm a') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a',
        okLabel: 'Set End',
        modal: true
        // dark: true
        // color: 'primary'
        // headerLabel: 'End Date / Time'
      },
      validation: {
        required: true
      }
    }
  }),
  createColumn({
    label: 'All Day',
    field: 'isAllDay',
    // section: 'Scheduling',
    type: 'boolean',
    description: 'Choosing this will ignore Start and End Date and mark the even as occurring all day.',
    defaultValue: false,
    component: booleanComponent
  }),
  createColumn({
    label: 'Short Description',
    field: 'shortDescription',
    isTitle: true,
    component: inputTextField({ req: false, max: 512 })
  }),
  createColumn({
    label: 'Event',
    field: 'event',
    ...relationField({
      type: 'one',
      namespace: 'event',
      filterIs: 'text-filter',
      localKey: 'eventId'
    })
  })
].concat(defaultColumns)
